<template>
  <v-card>
    <v-card-title>Добавить кросс-сейл</v-card-title>
    <v-card-text
      ><div align="center">
        <ProductCell
          v-if="selectedProduct"
          :product="selectedProduct"
          @click="itemSelect"
        />

        <div
          v-else
          @click="itemSelect"
          class="clickable-div"
        >
          Выбрать продукт
        </div>
      </div>
      <v-text-field
        v-model.number="priority"
        type="number"
        outlined
        hide-details
        dense
        label="Приоритет"
        class="mt-4" />
      <v-dialog
        v-model="productsSelectionDialog"
        max-width="700"
      >
        <ProductsSelectionDialog
          :select="select"
          :selectedProducts="selectedProducts"
        /> </v-dialog
    ></v-card-text>
    <v-card-actions>
      <v-row
        class="ma-0"
        justify="center"
        no-gutters
      >
        <v-btn
          :color="'primary'"
          depressed
          @click="confirm"
          class="mr-3"
          :loading="loading"
          >{{ shouldUpdate ? 'Обновить' : 'Подтвердить' }}
        </v-btn>
        <v-btn
          v-if="shouldUpdate"
          class="white--text"
          depressed
          color="red"
          @click="removeDialog = true"
          :disabled="loading"
          >{{ 'Удалить' }}
        </v-btn>
        <v-btn
          depressed
          color=""
          @click="close"
          class="ml-3"
          :disabled="loading"
        >
          Отменить
        </v-btn>
      </v-row>
    </v-card-actions>
    <!-- Диалог удаления -->
    <v-dialog
      v-model="removeDialog"
      max-width="400"
    >
      <v-card>
        <v-card-title>Удалить</v-card-title>
        <v-card-text>Удалить выбранный кросс-сейл товар?</v-card-text>
        <v-card-actions>
          <v-btn
            v-if="shouldUpdate"
            class="white--text"
            depressed
            color="primary"
            @click="remove"
            >{{ 'Удалить' }}
          </v-btn>
          <v-btn
            depressed
            color=""
            @click="removeDialog = false"
            class="ml-3"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import ProductsSelectionDialog from './productsSelection/ProductsSelectionDialog.vue'
  import ProductCell from './productsSelection/ProductCell.vue'
  import { CrossSell } from '@/models/crossseil.js'

  export default {
    name: 'CrossSellDialogItem',
    components: { ProductsSelectionDialog, ProductCell },
    props: {
      selectedProducts: [],
      item: {
        type: Object,
        required: false
      }
    },
    data: () => ({
      shouldUpdate: false,
      crossSellItem: null,
      selectedProduct: null,
      productsSelectionDialog: false,
      removeDialog: false,
      priority: 100,
      loading: false,
      crossSell: new CrossSell()
    }),
    methods: {
      itemSelect() {
        this.productsSelectionDialog = true
      },
      select(value) {
        this.productsSelectionDialog = false
        this.selectedProduct = value
      },
      close() {
        this.$emit('close')
      },
      remove() {
        if (this.shouldUpdate) {
          this.removeDialog = false
          this.loading = true

          this.crossSell
            .destroy(this.item.id)
            .then(() => {
              this.dialog = false
              this.$emit('remove', this.item)
              this.close()
            })
            .finally(() => {
              this.loading = false
            })
        }
      },
      confirm() {
        if (this.shouldUpdate) {
          this.update()
        } else {
          this.create()
        }
      },
      update() {
        const item = { ...this.item, product: this.selectedProduct.id, priority: this.priority }

        this.loading = true
        this.crossSell
          .update(item)
          .then(v => {
            this.$emit('update', v)
            this.close()
          })
          .finally(() => {
            this.loading = false
          })
      },
      create() {
        const item = {
          group: this.$productGroup.item.id,
          product: this.selectedProduct.id,
          priority: this.priority,
          active: true
        }

        this.loading = true
        this.crossSell
          .create(item)
          .then(v => {
            this.$emit('added', v)
            this.close()
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    mounted() {
      console.log('mounted')
      if (this.item != null) {
        this.selectedProduct = this.item.product
        this.priority = this.item.priority
        this.shouldUpdate = true
      }
    }
  }
</script>

<style scoped>
  .clickable-div {
    cursor: pointer;
    padding: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    min-height: 100px;
    transition: background-color 0.2s;
  }

  .clickable-div:hover {
    background-color: #f5f5f5;
  }
</style>
